module.exports = "https://www.gc-pro.gnp.com.mx/49aba0cb0a75ff100a9060555fa21224.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Stepper1@2x.svg
// module id = 1793
// module chunks = 0